import React, { useCallback } from "react";
import { Dropdown, DropdownMenu } from "@toddle-edu/ds-web";
import useToddleDocDownloadOptions from "./useToddleDocDownloadOptions";

const ToddleDocDownloadMenu = ({
  attachment,
  onDownload,
  children,
  testIdPrefix = "toddleDoc-download",
}) => {
  const {
    options,
    handleMenuVisibleChange,
    getIncludeCommentsFromKey,
  } = useToddleDocDownloadOptions({ attachment, testIdPrefix });

  const handleClick = useCallback(
    ({ key }) => {
      onDownload({
        attachment,
        includeComments: getIncludeCommentsFromKey(key),
      });
    },
    [onDownload, attachment, getIncludeCommentsFromKey]
  );

  return (
    <Dropdown
      onVisibleChange={handleMenuVisibleChange}
      overlay={
        <DropdownMenu
          dsVersion="2.0"
          options={options}
          onClick={handleClick}
          testId={`${testIdPrefix}-menu`}
        />
      }
    >
      {children}
    </Dropdown>
  );
};

export default ToddleDocDownloadMenu;
